<template>
  <div class="userinfo">
    <div class="info-container">
        <div class="info-row">
            <div class="info-item"><span class="item-title">group_id</span><span class="item-value">{{ userInfo.group_id }}</span></div>
            <div class="info-item"><span class="item-title">company</span><span class="item-value">{{ userInfo.company }}</span></div>
        </div>
        <div class="info-row">
            <div class="info-item"><span class="item-title">appid</span><span class="item-value">{{ userInfo.appid }}</span></div>
            <div class="info-item"><span class="item-title">秘钥</span><span class="item-value">{{ userInfo.key }}</span></div>
        </div>
    </div>
    <div class="title">API-1.0</div>
    <div class="set-container">
        <div class="set-row"><span class="row-title">手表定位推送</span><span v-if="data.locate" class="row-value">{{ data.locate }}</span><img src="@/assets/icon_edit.png" @click="handleSet('locate')"></div>
        <div class="set-row"><span class="row-title">SOS推送链接</span><span v-if="data.sos" class="row-value">{{ data.sos }}</span><img src="@/assets/icon_edit.png" @click="handleSet('sos')"></div>
        <div class="set-row"><span class="row-title">健康数据推送链接</span><span v-if="data.health" class="row-value">{{ data.health }}</span><img src="@/assets/icon_edit.png" @click="handleSet('health')"></div>
    </div>
    <div class="title">API-2.0</div>
    <div class="set-container">
      <div class="set-row"><span class="row-title">统一推送地址</span><span v-if="data.unified_url" class="row-value">{{ data.unified_url }}</span><img src="@/assets/icon_edit.png" @click="handleSet('unified_url')"></div>
    </div>
    <el-dialog
        :title="dialogInfo.title"
        :visible.sync="dialogInfo.visible"
        width="30%">
        <el-input v-model="sitter" placeholder="请输入内容"></el-input>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogInfo.visible = false">取 消</el-button>
            <el-button type="primary" @click="handleSure">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import { getGlobalInfo, setPushUrl } from '@/api/user'
export default {
  name: 'Home',
  components: {
  },
  created() {
    this.init()
  },
  data() {
    return {
      dialogInfo: {
        title: '',
        visible: false
      },
      sitter: '',
      urlType: '',
      data: {
        locate: '',
        sos: '',
        health: ''
      },
      userInfo: {
        group_id: '',
        company: '',
        appid: '',
        key: '',
      }
    }
  },
  methods: {
    init() {
      getGlobalInfo().then(response => {
        var {data} = response
        this.userInfo.group_id = data.group_id
        this.userInfo.company = data.company
        this.userInfo.appid = data.company_key
        this.userInfo.key = data.company_value

        this.data.locate = data.lbs_url
        this.data.sos = data.sos_url
        this.data.health = data.health_url
        this.data.unified_url = data.unified_url
        this.$nextTick(()=>{
            this.$forceUpdate()
        })
      })
    },
    handleSet(type) {
      this.urlType = type
      switch (type) {
        case "locate":
          this.dialogInfo.title = "编辑手表定位推送地址"
          this.sitter = this.data.locate
          this.dialogInfo.visible = true
          break;
        case "sos":
          this.dialogInfo.title = "编辑SOS推送链接"
          this.sitter = this.data.sos
          this.dialogInfo.visible = true
          break;
        case "health":
          this.dialogInfo.title = "健康数据推送链接"
          this.sitter = this.data.health
          this.dialogInfo.visible = true
          break;
        case "unified_url":
          this.dialogInfo.title = "统一推送链接"
          this.sitter = this.data.unified_url
          this.dialogInfo.visible = true
          break;
      }
    },
    handleSure() {
      if(this.sitter) {
        setPushUrl({type: this.urlType, url: this.sitter}).then(() => {
            this.$message({
                message: '恭喜你，操作成功',
                type: 'success'
            })
            this.init();
            this.dialogInfo.visible = false
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.userinfo{
    width: 50vw;
    max-width: 1200px;
    min-width: 1000px;
    margin: 0 auto;
    .info-container{
        margin-top: 50px;
        background-color: #fff;
        padding: 10px;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        .info-row{
            display: flex;
            padding: 14px 0;
            .info-item{
                text-align: left;
                flex: 0 0 500px;
                .item-title{
                    display: inline-block;
                    width: 120px;
                    text-align: right;
                    font-size: 18px;
                }
                .item-value{
                    margin-left: 10px;
                    font-size: 16px;
                    color: #999;
                }
            }
            
        }
    }
    .title{
      text-align: left;
      font-size: 20px;
      margin-top: 32px;
      margin-left: 10px;
    }
    .set-container{
        margin-top: 16px;
        padding: 18px 10px;
        background-color: #fff;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        .set-row{
            display: flex;
            align-items: center;
            padding: 18px 0;
            .row-title{
                flex: 0 0 160px;
                text-align: right;
                font-size: 18px;
            }
            .row-value{
                flex: 0 0 300px;
                margin-left: 10px;
                text-align: left;
                font-size: 16px;
                color: #666;
            }
            img{
              cursor: pointer;
              margin-left: 16px;
            }
        }
    }
}
</style>